module.exports = __webpack_public_path__ + "static/media/ESTAMOS_TOTALMENTE_CONTIGO_1080p.72175e08.jpg";